import './version';
export * from '@uifabric/styling';
//# sourceMappingURL=Styling.js.map